const NumberPage = ({ children = [] }) => {
  return (
    <div className="num-page-div h-auto">
      <span className="text-muted text-sm num-page-span">[{children}]</span>
    </div>
  );
};

export default NumberPage;
